import React from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "./styles";
import { Button } from "antd";
import { MdBook } from "react-icons/md";

export default function HeaderCourse({ name }) {
  const navigate = useNavigate();

  return (
    <Container>
      <div className="title">
        <p>GURUSEG CURSOS</p>
        {name && <p style={{ marginLeft: 50 }}>Curso: {name}</p>}
      </div>
      <Button
        onClick={() => {
          navigate(-1);
        }}
      >
        <MdBook />
        Voltar para a Área do conhecimento
      </Button>
    </Container>
  );
}
